package ru.it_mozaika.sender.js.application.components.triggers

import io.ktor.client.call.*
import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import ru.it_mozaika.sender.common.models.TriggerStatus
import ru.it_mozaika.sender.common.models.TriggerTitle
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.context.useBackdrop
import ru.it_mozaika.utils.checkResponseError
import web.cssom.*

external interface TriggersActionsDialogProps: Props {
    var selected: List<TriggerTitle>
    var delete: Boolean
    var stop: Boolean
    var start: Boolean
    var onClose: () -> Unit
}

val triggersActionsDialog = FC<TriggersActionsDialogProps> { props ->

    val (selected, setSelected) = useState<List<TriggerTitle>>(listOf())
    val backdrop = useBackdrop()
    useEffect(props.selected){
        setSelected(props.selected)
    }

    Dialog{
        this.open = props.start || props.stop || props.delete
        DialogTitle{
            if( props.stop) {
                +"Вы уверены что хотите остановить данные триггеры"
            }
            if( props.start) {
                +"Вы уверены что хотите запустить данные триггеры"
            }
            if( props.delete) {
                +"Вы уверены что хотите удалить данные триггеры. Данное действие будет невозможно отменить"
            }
        }
        DialogContent{
            FormControl {

                sx {
                    margin = 5.px
                    minWidth = 200.px
                }
                fullWidth = true
                InputLabel {
                    id = "triggers-list-action-label"
                    +"Триггеры"
                }
                Select {
                    labelId = "triggers-list-action-label"
                    id = "triggers-list-action"
                    value = selected.toTypedArray()
                    label = ReactNode("Триггеры")
                    multiple = true
                    onChange = onChange@{ e, _ ->
                        val ids = e.target.value.unsafeCast<Array<String>>()
                        val newList = ids.mapNotNull { id ->
                            props.selected.find { it.id == id }
                        }
                        setSelected(newList)
                    }
                    renderValue = useMemo(selected) {
                        { _ ->
                            Box.create {
                                sx {
                                    display = Display.flex
                                    flexWrap = FlexWrap.wrap
                                    asDynamic().gap = 0.5
                                }

                                selected.forEach { trigger ->
                                    Chip {
                                        deleteIcon = mui.icons.material.Cancel.create {
                                            onMouseDown = {
                                                it.stopPropagation()
                                            }
                                        }
                                        onDelete = {
                                            setSelected {
                                                it.minus(trigger)
                                            }
                                        }

                                        key = trigger.id
                                        label = ReactNode(trigger.name)
                                    }
                                }
                            }
                        }
                    }
                    props.selected.forEach { trigger ->
                        MenuItem {
                            this.selected = selected.contains(trigger)
                            value = trigger.id
                            + trigger.name
                        }
                    }
                }
            }
        }
        DialogActions{
            sx{
                alignItems = AlignItems.flexEnd
            }
            Stack{

                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button{
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    + "Да"
                    onClick = {
                        backdrop.show()
                        selected.forEach { trigger ->
                            if (props.delete){
                                Http.delete("/triggers/${trigger.id}") { response ->
                                    backdrop.hide()
                                    response.checkResponseError()?.let {
                                        showNotification(it, NotyType.Error)
                                        return@delete
                                    }
                                }
                            }
                            if (props.start && trigger.status != TriggerStatus.Started){
                                Http.get("/triggers/${trigger.id}/start") { response ->
                                    backdrop.hide()
                                    response.checkResponseError()?.let { error ->
                                        showNotification(error, NotyType.Error)
                                        return@get
                                    }
                                }
                            }
                            if(props.stop && trigger.status == TriggerStatus.Started){
                                Http.get("/triggers/${trigger.id}/stop") { response ->
                                    backdrop.hide()
                                    response.checkResponseError()?.let { error ->
                                        showNotification(error, NotyType.Error)
                                        return@get
                                    }
                                }
                            }
                        }

                        props.onClose()
                    }
                }
                Button{
                    + "Отмена"
                    variant = ButtonVariant.outlined
                    color = ButtonColor.error
                    onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}